import Container from "react-bootstrap/Container";
import React, { useState } from "react";
import Col from "react-bootstrap/Col";
import Carousel from "react-bootstrap/Carousel";
import { Button, Card, Row } from "react-bootstrap";
import Parser from "html-react-parser";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { library } from "@fortawesome/fontawesome-svg-core";
// import { fas } from '@fortawesome/free-solid-svg-icons'
import {
  faUsers,
  faMap,
  faHotel,
  faBus,
  faUtensils,
  faUserShield,
  faPersonHiking,
  faCircleExclamation,
} from "@fortawesome/free-solid-svg-icons";

function ItineraryDetails(props) {
  const { data } = props;

  return (
    <div style={{ paddingTop: "0px" }}>
      <Container>
        <div className="itinerary-day-cards">
          <Row>
            <Col md={6}>
              <ItineraryDayCards
                id={1}
                title="GROUP"
                subtitle=""
                faIcon={faUsers}
              >
                {Parser(data.group_size)}
              </ItineraryDayCards>
            </Col>
            <Col md={6}>
              <ItineraryDayCards
                id={1}
                title="ROUTE"
                subtitle=""
                faIcon={faMap}
              >
                {Parser(data.route)}
              </ItineraryDayCards>
            </Col>
          </Row>
          <br />
          <br />
          <Row>
            <Col md={6}>
              <ItineraryDayCards
                id={1}
                title="ACTIVITIES"
                subtitle=""
                faIcon={faPersonHiking}
              >
                <ul>{Parser(data.activities)}</ul>
              </ItineraryDayCards>
            </Col>

            <Col md={6}>
              <ItineraryDayCards
                id={1}
                title="TRANSPORT"
                subtitle=""
                faIcon={faBus}
              >
                {Parser(data.transportation)}
              </ItineraryDayCards>
            </Col>

           
          </Row>
          <br />
          <Row>
            <Col md={6}>
              <ItineraryDayCards
                id={1}
                title="MEALS"
                subtitle=""
                faIcon={faUtensils}
              >
                {Parser(data.meals)}
              </ItineraryDayCards>
            </Col>
            <Col md={6}>
              <ItineraryDayCards
                id={1}
                title="STAYS"
                subtitle=""
                faIcon={faHotel}
              >
                {Parser(data.stays)}
              </ItineraryDayCards>
            </Col>
          </Row>
          <br />
          <br />
          <Row>
            {/* <Col md={6}>
              <ItineraryDayCards
                id={1}
                title="INCLUSIONS"
                subtitle=""
                faIcon={faPersonHiking}
              >
                <ul>
                  {data.inclusions.map((item, i) => {
                    return (
                      <li key={`ItineraryDetails-inclusions-${i}`}>
                        {Parser(item)}
                      </li>
                    );
                  })}
                </ul>
              </ItineraryDayCards>
            </Col> */}
             <Col md={6}>
              <ItineraryDayCards
                id={1}
                title="CREW"
                subtitle=""
                faIcon={faUserShield}
              >
                {Parser(data.your_crew)}
              </ItineraryDayCards>
            </Col>
            {/* <Col md={4}>
              <ItineraryDayCards
                id={1}
                title="FREE TIME SUGGESTIONS & OPTIONAL EXTRAS"
                subtitle=""
                faIcon={faPersonHiking}
              >
                <ul>
                  <li>Tokyo Skytree</li>
                </ul>
              </ItineraryDayCards>
            </Col> */}
            <Col md={6}>
              <ItineraryDayCards
                id={1}
                title="EXCULSIONS"
                subtitle=""
                faIcon={faCircleExclamation}
              >
                <ul>
                  {data.exclusions.map((item, i) => {
                    return (
                      <li key={`ItineraryDetails-exclusions-${i}`}>
                        {Parser(item)}
                      </li>
                    );
                  })}
                </ul>
              </ItineraryDayCards>
            </Col>
          </Row>
        </div>
      </Container>
    </div>
  );
}

export default ItineraryDetails;

function ItineraryDayCards(props) {
  const [hideReadmore, setHideReadmore] = useState(true);

  function toggleReadMore() {
    setHideReadmore(false);
    var elements = findChild(`Itinerary-${props.id}`, "collapse");

    if (elements) {
      elements.classList.remove("collapse");
      elements.classList.add("collapse.show");
    }
  }

  function findChild(idOfElement, idOfChild) {
    let element = document.getElementById(idOfElement);
    return element.querySelector("[class=" + idOfChild + "]");
  }

  return (
    <Card>
      <Card.Body id={`Itinerary-${props.id}`} aria-controls="collapse">
        <Card.Title>
          <FontAwesomeIcon icon={props.faIcon} /> {props.title}
        </Card.Title>
        <Card.Text>
          <h5>{props.subtitle}</h5>
          {props.children}
        </Card.Text>
      </Card.Body>
    </Card>
  );
}
